import { DefaultMetricOptions, Goal, GoalType } from '@griply/types';

// A project always measures task completion, whatever metric it carried over from being a goal.
export const isTaskMeasuredGoal = (goal: Goal | undefined): boolean =>
  !!goal &&
  (goal.type === GoalType.Project ||
    goal.metric?.id === DefaultMetricOptions.CompletedTasks);
